// Accept numeric JSON values and legacy numeric strings, never NaN or infinity.
export function callSeconds(value, fallback = 0) {
  if ((typeof value !== 'number' && typeof value !== 'string') || value === '') return fallback;
  const number = Number(value);
  return Number.isFinite(number) ? Math.max(0, Math.floor(number)) : fallback;
}
